import { render, staticRenderFns } from "./Mediations.vue?vue&type=template&id=3a36a0be&scoped=true&"
import script from "./Mediations.vue?vue&type=script&lang=ts&"
export * from "./Mediations.vue?vue&type=script&lang=ts&"
import style0 from "./Mediations.vue?vue&type=style&index=0&id=3a36a0be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a36a0be",
  null
  
)

/* custom blocks */
import block0 from "./Mediations.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
